import LoadingActionContext from "@/context/LoadingActionContext";
import { FC, useContext, useEffect } from "react";

const Loading: FC<{ name: string; isLoading: boolean; isValidating: boolean; }> = ({
    name,
    isLoading,
    isValidating
}) => {
    const { setLoading, setComplete, setValid, setValidating } = useContext(LoadingActionContext);
    
    useEffect(() => {
        if (isLoading) {
            setLoading(name);
        }
        else {
            setTimeout(() => setComplete(name), 0);
        }
    }, [isLoading, setLoading, setComplete])

    useEffect(() => {
        if (isValidating) {
            setValidating(name);
        }
        else {
            setValid(name);
        }
    }, [isValidating, setValidating, setValid])

    useEffect(() => {
        return () => {
            setComplete(name);
            setValid(name);
        }
    }, [setComplete, setValid])

    return null;
};

export default Loading;